<template>
	<div style="width:100%;height:100%;">
		<div class="title">
			<p>排气压力 Mpa</p>
		</div>
		<div class="echarts">
			<div id="echartsone" style="width:100%;height:100%" v-show="echartsones"></div>
		</div>
	</div>
</template>

<script>
import * as echarts from 'echarts'
import DataService from '@/api/data'
import { utils } from "@/utils/index.js";
var myChart

export default {

	data() {
		return {
			switch: true,
			echartsones: true,
			echartstwos: false,
			serialNumber:'',
			equipmentModel:'',
			chartsData:[],
			chartsTime:[],
			date:[],
			time_interval:'0'
		}
	},
	created(){
        if(this.$route.query.serial_number){
            this.serialNumber = this.$route.query.serial_number;
            this.equipmentModel = this.$route.query.equipment_model;
        }
    },
	methods: {
		//获取趋势图数据
		getTrendChart(){
			let list
			if(this.equipmentModel == 'centrifuge_old'){
				list = 'var40000'
			}else{
				list = 'var40003'
			}
			DataService.trendChartOf3D({
				list:list,
				serialNumber:this.serialNumber,
				equipmentModel:this.equipmentModel,
				startTime:this.date[0],
				endTime:this.date[1],
			}).then(res=>{
				if(res.data != null){
					this.chartsData = res.data.namedate['排气压力(MPa)']
					this.chartsTime = res.data.time
					this.echartsone();
				}
			}).catch(err=>{
				this.$message.error(err.message)
			})
		},
		time_intervalChange(){
			const endTime = utils.formatDate(new Date().getTime())
			switch (this.time_interval) {
				case '0':
				this.date = [utils.formatDate(new Date().getTime()-600000),endTime];
				break;
				case '1':
				this.date = [utils.formatDate(new Date().getTime()-3600000),endTime];
				break;
				case '2':
				this.date = [utils.formatDate(new Date().getTime()-7200000),endTime];
				break;
				case '3':
				this.date = [utils.formatDate(new Date().getTime()-10800000),endTime];
				break;
				case '4':
				this.date = [utils.formatDate(new Date().getTime()-14400000),endTime];
				break;
				case '5':
				this.date = [utils.formatDate(new Date().getTime()-28800000),endTime];
				break;
				case '6':
				this.date = [utils.formatDate(new Date().getTime()-43200000),endTime];
				break;
				default:
				this.date = [utils.formatDate(new Date().getTime()-600000),endTime];
				break;
			}
			this.getTrendChart()
		},
		echartsone() {
			echarts.init(document.getElementById('echartsone')).dispose()
			myChart = echarts.init(document.getElementById('echartsone'))

			myChart.setOption({
				// backgroundColor: '#424956',
				// title: {
				//     text: '请求数',
				//     textStyle: {
				//         fontWeight: 'normal',
				//         fontSize: 16,
				//         color: '#F1F1F3'
				//     },
				//     left: '6%'
				// },
				dataZoom: [
					{
						start: 0,
						end: 100,
						//  startValue:50,
						//  endValue:100,
						type: "inside",
					},
				],
				tooltip: {
					trigger: 'axis',
					axisPointer: {
						lineStyle: {
							color: '#dddddd'
						}
					}
				},
				// legend: {
				// 	// icon: 'rect',
				// 	itemWidth: 17,
				// 	itemHeight: 9,
				// 	itemGap: 13,
				// 	data: ['排气压力 ',],
				// 	left: '1%',
				// 	textStyle: {
				// 		fontSize: 12,
				// 		color: "RGBA(129, 194, 248, 1)",
				// 	}
				// },
				grid: {
					top: '18%',
					left: '2%',
					right: '6%',
					bottom: '2%',
					containLabel: true
				},
				xAxis: [{
					type: 'category',
					boundaryGap: false,
					axisLine: {
						lineStyle: {
							color: '#dddddd'
						},
						textStyle: {
							fontSize: 11
						}
					},
					data: this.chartsTime.map(function (str) {
						return str.substring(10,19);
					}),
				}],
				yAxis: [{
					type: 'value',
					// name: 'Mpa',
					min: 0,
					max: 2,
					interval: 0.5,
					nameTextStyle: {
						padding: [1, 1, -3, -33]
					},
					axisTick: {
						show: false
					},
					axisLine: {
						lineStyle: {
							color: '#dddddd'
						}
					},
					axisLabel: {
						margin: 10,
						textStyle: {
							fontSize: 11
						}
					},
					splitLine: {
						lineStyle: {
							color: '#57617B'
						}
					}
				}],
				series: [{
					name: '排气压力 ',
					type: 'line',
					smooth: true,
					symbol: 'circle',
					symbolSize: 5,
					showSymbol: false,
					lineStyle: {
						normal: {
							width: 3
						}
					},
					areaStyle: {
						normal: {
							color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
								offset: 0,
								color: 'rgba(16,97,204, 0.3)'
							}, {
								offset: 0.8,
								color: 'rgba(17,235,210, 0)'
							}], false),
							shadowColor: 'rgba(0, 0, 0, 0.1)',
							shadowBlur: 10
						}
					},
					itemStyle: {
						normal: {

							color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
								offset: 0,
								color: 'rgba(16,97,204,1)'
							}, {
								offset: 1,
								color: 'rgba(17,235,210,1)'
							}])
						},
						emphasis: {
							color: 'rgb(0,196,132)',
							borderColor: 'rgba(0,196,132,0.2)',
							extraCssText: 'box-shadow: 8px 8px 8px rgba(0, 0, 0, 1);',
							borderWidth: 10
						}
					},
					data: this.chartsData
				},
					// {
					//     name: '电信',
					//     type: 'line',
					//     smooth: true,
					//     symbol: 'circle',
					//     symbolSize: 5,
					//     showSymbol: false,
					//     lineStyle: {
					//         normal: {
					//             width: 3
					//         }
					//     },
					//     areaStyle: {
					//         normal: {
					//             color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
					//                 offset: 0,
					//                 color: 'rgba(205,52,42, 0.5)'
					//             }, {
					//                 offset: 0.8,
					//                 color: 'rgba(235,235,21, 0)'
					//             }], false),
					//             shadowColor: 'rgba(0, 0, 0, 0.1)',
					//             shadowBlur: 10
					//         },
					//     },
					//    itemStyle: {
					//             normal: {

					//                 color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
					//                     offset: 0,
					//                     color: 'rgba(205,52,42,1)'
					//                 }, {
					//                     offset: 1,
					//                     color: 'rgba(235,235,21,1)'
					//                 }])
					//             },
					//             emphasis: {
					//             color: 'rgb(99,250,235)',
					//             borderColor: 'rgba(99,250,235,0.2)',
					//             extraCssText: 'box-shadow: 8px 8px 8px rgba(0, 0, 0, 1);',
					//             borderWidth: 10
					//         }
					//         },
					//     data: [120, 110, 125, 145, 122, 165, 122, 220]
					// } 
				]
			},true);
		},

	},
	mounted() {
		if(sessionStorage.getItem('time_interval')){
			this.time_interval = sessionStorage.getItem('time_interval')
		}
		this.time_intervalChange()
		window.addEventListener("resize", () => {
			echarts.init(document.getElementById("echartsone")).resize();
		});
		this.interval = setInterval(this.time_intervalChange, 30000);
	},
	beforeDestroy() {
		clearInterval(this.interval);
	},
}
</script>

<style  scoped>
* {
	margin: 0;
	padding: 0;
}
.title {
	width: 100%;
	height: 9%;
	display: flex;
	align-items: center;
	background: url(../../assets/img/centrifuge/title.png) no-repeat;
	background-size: 100% 100%;
}
.title p {
	display: flex;
	align-items: center;
	width: 100%;
	height: 100%;
	font-size: 0.8vw;
	color: white;
	margin-left: 2vw;
}
.echarts {
	width: 100%;
	height: 90%;
	/* background-color: aquamarine; */
}
</style>